import { BillConceptos } from '../../../models/Factura';

/** Blank concepto for a nota de crédito, defaults to the SAT "devolución" claves */
export const EMPTY_CONCEPTO_DEVOLUCION = (): BillConceptos => (JSON.parse(JSON.stringify({
    claveProdServ: '84111506',
    claveUnidad: 'ACT',
    cantidad: 1,
    descripcion: 'Devolución',
    valorUnitario: 0,
    descuento: 0,
    noIdentificacion: '',
    impuestos: [{ type: 'iva', tipo: 'Fijo', retencion: false, tasa: 0.16 }]
})))
